import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
						<a href="https://www.jumpin.co.in/" target="_blank" style={{display:"flex"}}>
							<img
								src="https://static.wixstatic.com/media/20220f_2dfb63401cc142919118c8ea9ecd239f~mv2.png/v1/fill/w_195,h_187,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/png%20logo%20jumpin_edited.png"
								alt="jumpin"
								className="work-image"
							/>
							<div className="work-title">JumpIn</div>
							<div className="work-subtitle">
								Social Media Marketing Intern
							</div>
							<div className="work-duration">Jan 2022 - Feb 2022</div>
							</a>
						</div>

						<div className="work">
						<a href="https://parivartan-nfts.web.app" target="_blank" style={{display:"flex"}}>
							<img
								src="./parivartan.png"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Parivartan.web</div>
							<div className="work-subtitle">
								Web Developer
							</div>
							<div className="work-duration">Jan 2023 - Present</div>
							</a>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
